import { Shield, Zap, Flame, Star, Crown, Feather, Swords, Mountain, Trophy, Anchor } from "lucide-react";

export const CRESTS = {
  shield: Shield,
  zap: Zap,
  flame: Flame,
  star: Star,
  crown: Crown,
  feather: Feather,
  swords: Swords,
  mountain: Mountain,
  trophy: Trophy,
  anchor: Anchor,
};

export const crestKeys = Object.keys(CRESTS);
